import { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useComfort } from "../app/ComfortContext";
import { getDictionary, LOCALE_LABEL, type Locale } from "../i18n/dictionary";
import "./portal.css";

type AuthView = "signin" | "sent" | "expired" | "app";

// ---- Inline SVGs (from prototype) ----------------------------------------

function IconHome() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 11l9-8 9 8" /><path d="M5 10v10h14V10" />
    </svg>
  );
}
function IconChildren() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="9" cy="8" r="3" /><path d="M3 19a6 6 0 0112 0" /><path d="M16 6a3 3 0 010 6" /><path d="M22 19a6 6 0 00-4-5.7" />
    </svg>
  );
}
function IconAssign() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="6" y="4" width="12" height="17" rx="2" /><path d="M9 4h6v3H9z" /><path d="M9 12h6M9 16h4" />
    </svg>
  );
}
function IconExport() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M14 3H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V8z" /><path d="M14 3v5h5" /><path d="M12 18v-6M9 15l3-3 3 3" />
    </svg>
  );
}
function IconLink() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M10 13a5 5 0 007 0l2-2a5 5 0 00-7-7l-1 1" /><path d="M14 11a5 5 0 00-7 0l-2 2a5 5 0 007 7l1-1" />
    </svg>
  );
}
function IconConsent() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 3l8 4v5c0 5-3.5 8-8 9-4.5-1-8-4-8-9V7z" /><path d="M9 12l2 2 4-4" />
    </svg>
  );
}
function IconSettings() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="3" />
      <path d="M19 12a7 7 0 00-.1-1l2-1.5-2-3.4-2.3 1a7 7 0 00-1.7-1L16.5 3h-4l-.4 2.6a7 7 0 00-1.7 1l-2.3-1-2 3.4L6 10a7 7 0 000 2l-2 1.5 2 3.4 2.3-1a7 7 0 001.7 1l.4 2.6h4l.4-2.6a7 7 0 001.7-1l2.3 1 2-3.4-2-1.5a7 7 0 00.1-1z" />
    </svg>
  );
}
function IconSignOut() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" /><path d="M16 17l5-5-5-5M21 12H9" />
    </svg>
  );
}
function IconMenu() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M4 7h16M4 12h16M4 17h16" />
    </svg>
  );
}
function IconClose() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M6 6l12 12M18 6L6 18" />
    </svg>
  );
}
function IconCalm() {
  return (
    <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 12c3-4 6-4 9 0s6 4 9 0" />
    </svg>
  );
}
function IconText() {
  return (
    <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M4 7V5h12v2M10 5v14M7 19h6M17 13v-1h5v1M19.5 12v7M18 19h3" />
    </svg>
  );
}
function IconSpacing() {
  return (
    <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 6h18M3 12h18M3 18h18" />
    </svg>
  );
}
function IconContrast() {
  return (
    <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="9" /><path d="M12 3a9 9 0 010 18z" fill="currentColor" />
    </svg>
  );
}
function IconMoon() {
  return (
    <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M21 12.8A9 9 0 1111.2 3a7 7 0 009.8 9.8z" />
    </svg>
  );
}
function IconGlobe() {
  return (
    <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3a14 14 0 010 18M12 3a14 14 0 000 18" />
    </svg>
  );
}
function IconMail() {
  return (
    <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="var(--brand-hover)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="5" width="18" height="14" rx="3" /><path d="M3 7l9 6 9-6" />
    </svg>
  );
}
function IconWarning() {
  return (
    <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="var(--peach-deep)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="9" /><path d="M12 7v5M12 16h.01" />
    </svg>
  );
}
function IconUser() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="var(--brand-hover)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0116 0" />
    </svg>
  );
}
function ZooyloLogo({ size = 34 }: { size?: number }) {
  return (
    <svg viewBox="0 0 48 48" width={size} height={size} aria-hidden="true">
      <rect x="2" y="2" width="44" height="44" rx="14" fill="var(--brand)" />
      <circle cx="18" cy="20" r="4" fill="#FBF7F0" />
      <circle cx="30" cy="20" r="4" fill="#FBF7F0" />
      <path d="M16 30 Q24 37 32 30" stroke="#FBF7F0" strokeWidth="3" fill="none" strokeLinecap="round" />
    </svg>
  );
}

// ---- Comfort panel (mobile) -----------------------------------------------

interface ComfortPanelProps {
  dict: ReturnType<typeof getDictionary>;
  locale: Locale;
  calm: boolean;
  bigText: boolean;
  spacing: boolean;
  contrast: boolean;
  dark: boolean;
  toggle: (key: "calm" | "bigText" | "spacing" | "contrast" | "dark") => void;
  setLocale: (l: Locale) => void;
  onClose: () => void;
}

function ComfortPanel({
  dict,
  locale,
  calm,
  bigText,
  spacing,
  contrast,
  dark,
  toggle,
  setLocale,
  onClose,
}: ComfortPanelProps) {
  const tc = dict.comfort;
  const btnStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: 12,
    width: "100%",
    minHeight: 52,
    padding: "0 16px",
    border: "1px solid var(--line-strong)",
    background: "var(--surface)",
    color: "var(--ink-soft)",
    borderRadius: "var(--r-pill)",
    fontFamily: "var(--font-body)",
    fontWeight: 600,
    fontSize: 15,
    cursor: "pointer",
    textAlign: "left" as const,
  };
  const nextLocale: Locale = locale === "en" ? "ms" : "en";
  return (
    <>
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(35,44,56,.32)",
          zIndex: 70,
        }}
      />
      <div
        style={{
          position: "fixed",
          insetInline: 0,
          bottom: 0,
          background: "var(--bg)",
          borderTopLeftRadius: "var(--r-xl)",
          borderTopRightRadius: "var(--r-xl)",
          padding: "24px 20px 32px",
          zIndex: 71,
          boxShadow: "var(--sh-2)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
          <span style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 20, color: "var(--ink-deep)" }}>
            {tc.title}
          </span>
          <button onClick={onClose} style={{ width: 38, height: 38, border: 0, background: "var(--surface-sunk)", borderRadius: "var(--r-sm)", cursor: "pointer", color: "var(--ink-soft)", display: "grid", placeItems: "center" }}>
            <IconClose />
          </button>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <button className="zcomfort" data-on={String(calm)} onClick={() => toggle("calm")} style={btnStyle}>
            <IconCalm /> {tc.calmMode}
          </button>
          <button className="zcomfort" data-on={String(bigText)} onClick={() => toggle("bigText")} style={btnStyle}>
            <IconText /> {tc.biggerText}
          </button>
          <button className="zcomfort" data-on={String(spacing)} onClick={() => toggle("spacing")} style={btnStyle}>
            <IconSpacing /> {tc.readingSpacing}
          </button>
          <button className="zcomfort" data-on={String(contrast)} onClick={() => toggle("contrast")} style={btnStyle}>
            <IconContrast /> {tc.higherContrast}
          </button>
          <button className="zcomfort" data-on={String(dark)} onClick={() => toggle("dark")} style={btnStyle}>
            <IconMoon /> {tc.darkTheme}
          </button>
          <button onClick={() => { setLocale(nextLocale); onClose(); }} style={{ ...btnStyle, marginTop: 4 }}>
            <IconGlobe /> {LOCALE_LABEL[nextLocale]}
          </button>
        </div>
      </div>
    </>
  );
}

// ---- Comfort cluster (topbar) ---------------------------------------------

interface ComfortClusterProps {
  dict: ReturnType<typeof getDictionary>;
  locale: Locale;
  calm: boolean;
  bigText: boolean;
  spacing: boolean;
  contrast: boolean;
  dark: boolean;
  toggle: (key: "calm" | "bigText" | "spacing" | "contrast" | "dark") => void;
  setLocale: (l: Locale) => void;
  onOpenPanel: () => void;
}

function ComfortCluster({
  dict,
  locale,
  calm,
  bigText,
  spacing,
  contrast,
  dark,
  toggle,
  setLocale,
  onOpenPanel,
}: ComfortClusterProps) {
  const tc = dict.comfort;
  const nextLocale: Locale = locale === "en" ? "ms" : "en";
  const btn: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: 6,
    height: 42,
    padding: "0 14px",
    border: "1px solid var(--line-strong)",
    background: "var(--surface)",
    color: "var(--ink-soft)",
    borderRadius: "var(--r-pill)",
    fontFamily: "var(--font-body)",
    fontWeight: 600,
    fontSize: 13.5,
    cursor: "pointer",
    whiteSpace: "nowrap" as const,
  };
  return (
    <>
      <div className="zcomfort-cluster" style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <button className="zcomfort" data-on={String(calm)} onClick={() => toggle("calm")} title={tc.calmMode} style={btn}>
          <IconCalm /> {tc.calm}
        </button>
        <button className="zcomfort" data-on={String(bigText)} onClick={() => toggle("bigText")} title={tc.biggerText} style={btn}>
          <IconText /> {tc.text}
        </button>
        <button className="zcomfort" data-on={String(spacing)} onClick={() => toggle("spacing")} title={tc.readingSpacing} style={btn}>
          <IconSpacing /> {tc.spacing}
        </button>
        <button className="zcomfort" data-on={String(contrast)} onClick={() => toggle("contrast")} title={tc.higherContrast} style={btn}>
          <IconContrast /> {tc.contrast}
        </button>
        <button className="zcomfort" data-on={String(dark)} onClick={() => toggle("dark")} title={tc.darkTheme} style={btn}>
          <IconMoon /> {dark ? tc.light : tc.dark}
        </button>
        <button onClick={() => setLocale(nextLocale)} title={dict.language.title} style={btn}>
          <IconGlobe /> {LOCALE_LABEL[nextLocale]}
        </button>
      </div>
      <button className="zcomfort-more" onClick={onOpenPanel} title={tc.title}
        style={{ display: "none", alignItems: "center", gap: 7, height: 42, padding: "0 14px", border: "1px solid var(--line-strong)", background: "var(--surface)", color: "var(--ink-soft)", borderRadius: "var(--r-pill)", fontFamily: "var(--font-body)", fontWeight: 600, fontSize: 13.5, cursor: "pointer" }}>
        <IconCalm /> {tc.title}
      </button>
    </>
  );
}

// ---- Sign-in screen -------------------------------------------------------

interface SignInScreenProps {
  dict: ReturnType<typeof getDictionary>;
  locale: Locale;
  email: string;
  sending: boolean;
  onEmail: (v: string) => void;
  onSend: () => void;
  setLocale: (l: Locale) => void;
}

function SignInScreen({ dict, locale, email, sending, onEmail, onSend, setLocale }: SignInScreenProps) {
  const t = dict.service.signIn;
  const c = dict.common;
  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 32, position: "relative", overflow: "hidden" }}>
      <div style={{ position: "absolute", top: -160, insetInlineStart: -120, width: 520, height: 520, borderRadius: "50%", background: "radial-gradient(circle, var(--sky-tint), transparent 70%)", filter: "blur(8px)", pointerEvents: "none" }} />
      <div style={{ position: "absolute", bottom: -180, insetInlineEnd: -120, width: 560, height: 560, borderRadius: "50%", background: "radial-gradient(circle, var(--peach-tint), transparent 70%)", filter: "blur(8px)", pointerEvents: "none" }} />
      <div style={{ position: "absolute", top: 24, insetInlineEnd: 28, display: "flex", gap: 3, padding: 4, background: "var(--surface)", border: "1px solid var(--line)", borderRadius: "var(--r-pill)", boxShadow: "var(--sh-1)" }}>
        <button className="zseg" data-on={String(locale === "en")} onClick={() => setLocale("en")} style={{ border: 0, background: "transparent", color: "var(--ink-soft)", fontFamily: "var(--font-body)", fontWeight: 600, fontSize: 13, padding: "8px 13px", borderRadius: "var(--r-pill)", cursor: "pointer" }}>English</button>
        <button className="zseg" data-on={String(locale === "ms")} onClick={() => setLocale("ms")} style={{ border: 0, background: "transparent", color: "var(--ink-soft)", fontFamily: "var(--font-body)", fontWeight: 600, fontSize: 13, padding: "8px 13px", borderRadius: "var(--r-pill)", cursor: "pointer" }}>Bahasa Melayu</button>
      </div>
      <div style={{ position: "relative", width: "100%", maxWidth: 440 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 28, justifyContent: "center" }}>
          <ZooyloLogo size={40} />
          <span style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 28, color: "var(--brand)", letterSpacing: "-.02em" }}>zooylo</span>
        </div>
        <div style={{ background: "var(--surface)", border: "1px solid var(--line)", borderRadius: "var(--r-xl)", boxShadow: "var(--sh-1)", padding: "36px 34px" }}>
          <h1 style={{ fontFamily: "var(--font-display)", fontSize: 28, color: "var(--ink-deep)", margin: 0 }}>{t.title}</h1>
          <p style={{ color: "var(--ink-soft)", marginTop: 10, fontSize: 16, lineHeight: 1.6, margin: "10px 0 0" }}>{t.body}</p>
          <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 24 }}>
            <label htmlFor="sp-email-input" style={{ fontWeight: 600, fontSize: 14, color: "var(--ink)", letterSpacing: ".02em" }}>{t.emailLabel}</label>
            <input
              id="sp-email-input"
              value={email}
              onChange={(e) => onEmail(e.target.value)}
              type="email"
              placeholder="you@example.com"
              style={{ minHeight: 52, padding: "14px 16px", fontSize: 17, fontFamily: "var(--font-body)", color: "var(--ink)", background: "var(--surface)", border: "2px solid var(--line-strong)", borderRadius: "var(--r-md)", width: "100%", outline: "none" }}
            />
            <span style={{ fontSize: 13.5, color: "var(--ink-faint)" }}>{t.emailHint}</span>
          </div>
          <button
            onClick={onSend}
            disabled={sending}
            style={{ marginTop: 22, width: "100%", minHeight: 54, border: 0, borderRadius: "var(--r-pill)", background: "var(--brand)", color: "#fff", fontFamily: "var(--font-body)", fontWeight: 600, fontSize: 17, cursor: sending ? "wait" : "pointer", boxShadow: "var(--sh-1)", display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}
          >
            {sending && (
              <span style={{ width: 18, height: 18, border: "2px solid rgba(255,255,255,.5)", borderTopColor: "#fff", borderRadius: "50%", animation: "zspin .8s linear infinite" }} />
            )}
            {sending ? c.sending : c.sendMagicLink}
          </button>
        </div>
        <p style={{ textAlign: "center", color: "var(--ink-faint)", fontSize: 13.5, marginTop: 18 }}>{t.guardrail}</p>
      </div>
    </div>
  );
}

// ---- Link sent screen -----------------------------------------------------

interface SentScreenProps {
  dict: ReturnType<typeof getDictionary>;
  email: string;
  onContinue: () => void;
  onDifferentEmail: () => void;
  onSimulateExpired: () => void;
}

function SentScreen({ dict, email, onContinue, onDifferentEmail, onSimulateExpired }: SentScreenProps) {
  const c = dict.common;
  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 32, position: "relative", overflow: "hidden" }}>
      <div style={{ position: "absolute", top: -160, insetInlineEnd: -120, width: 520, height: 520, borderRadius: "50%", background: "radial-gradient(circle, var(--sage-tint), transparent 70%)", filter: "blur(8px)", pointerEvents: "none" }} />
      <div style={{ position: "relative", width: "100%", maxWidth: 440, textAlign: "center" }}>
        <div style={{ width: 88, height: 88, borderRadius: "var(--r-lg)", background: "var(--brand-tint)", display: "grid", placeItems: "center", margin: "0 auto 22px" }}>
          <IconMail />
        </div>
        <h1 style={{ fontSize: 28, color: "var(--ink-deep)", margin: 0 }}>{c.checkInbox}</h1>
        <p style={{ color: "var(--ink-soft)", marginTop: 12, fontSize: 16, lineHeight: 1.6, margin: "12px 0 0" }}>
          We sent a link to <b style={{ color: "var(--ink)" }}>{email || "your inbox"}</b>. Tap it to sign in.
        </p>
        <button onClick={onContinue} style={{ marginTop: 26, minHeight: 54, padding: "0 30px", border: 0, borderRadius: "var(--r-pill)", background: "var(--brand)", color: "#fff", fontWeight: 600, fontSize: 17, cursor: "pointer", boxShadow: "var(--sh-1)" }}>
          {c.continue}
        </button>
        <div style={{ marginTop: 16, display: "flex", gap: 18, justifyContent: "center", flexWrap: "wrap" }}>
          <button onClick={onDifferentEmail} style={{ background: "transparent", border: 0, color: "var(--ink-soft)", fontFamily: "var(--font-body)", fontSize: 15, cursor: "pointer", textDecoration: "underline", textUnderlineOffset: 3 }}>{c.useDifferentEmail}</button>
          <button onClick={onSimulateExpired} style={{ background: "transparent", border: 0, color: "var(--ink-faint)", fontFamily: "var(--font-body)", fontSize: 15, cursor: "pointer", textDecoration: "underline", textUnderlineOffset: 3 }}>Simulate expired link</button>
        </div>
      </div>
    </div>
  );
}

// ---- Link expired screen --------------------------------------------------

interface ExpiredScreenProps {
  dict: ReturnType<typeof getDictionary>;
  onSend: () => void;
}

function ExpiredScreen({ dict, onSend }: ExpiredScreenProps) {
  const c = dict.common;
  const t = dict.service.signIn;
  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 32, position: "relative", overflow: "hidden" }}>
      <div style={{ position: "absolute", bottom: -180, insetInlineStart: -120, width: 520, height: 520, borderRadius: "50%", background: "radial-gradient(circle, var(--peach-tint), transparent 70%)", filter: "blur(8px)", pointerEvents: "none" }} />
      <div style={{ position: "relative", width: "100%", maxWidth: 440, textAlign: "center" }}>
        <div style={{ width: 88, height: 88, borderRadius: "var(--r-lg)", background: "var(--peach-tint)", display: "grid", placeItems: "center", margin: "0 auto 22px" }}>
          <IconWarning />
        </div>
        <h1 style={{ fontSize: 28, color: "var(--ink-deep)", margin: 0 }}>{c.linkExpired}</h1>
        <p style={{ color: "var(--ink-soft)", marginTop: 12, fontSize: 16, lineHeight: 1.6, margin: "12px 0 0" }}>{t.expiredBody}</p>
        <button onClick={onSend} style={{ marginTop: 26, minHeight: 54, padding: "0 30px", border: 0, borderRadius: "var(--r-pill)", background: "var(--brand)", color: "#fff", fontWeight: 600, fontSize: 17, cursor: "pointer", boxShadow: "var(--sh-1)" }}>
          {c.sendNewLink}
        </button>
      </div>
    </div>
  );
}

// ---- Nav item button -------------------------------------------------------

interface NavItemProps {
  label: string;
  active: boolean;
  onClick: () => void;
  icon: React.ReactNode;
}

function NavItem({ label, active, onClick, icon }: NavItemProps) {
  return (
    <button
      className="znav-item"
      data-on={String(active)}
      onClick={onClick}
      style={{ display: "flex", alignItems: "center", gap: 12, minHeight: 48, padding: "0 14px", border: 0, background: "transparent", color: "var(--ink-soft)", fontFamily: "var(--font-body)", fontWeight: 600, fontSize: 15.5, borderRadius: "var(--r-md)", cursor: "pointer", textAlign: "start", width: "100%" }}
    >
      {icon} {label}
    </button>
  );
}

// ---- ServicePortal --------------------------------------------------------

interface ServicePortalProps {
  /** Signed-in account email (real-auth path). Undefined in the demo path. */
  accountEmail?: string;
  /** Signed-in Supabase user id (real-auth path). Passed to screens via Outlet. */
  accountId?: string;
  /** Real sign-out. When absent, the built-in demo sign-in stub is shown instead. */
  onSignOut?: () => void;
}

export function ServicePortal({ accountEmail, accountId, onSignOut }: ServicePortalProps = {}) {
  const { calm, bigText, spacing, contrast, dark, locale, toggle, setLocale } = useComfort();
  const dict = getDictionary(locale);
  const t = dict.service;
  const [authView, setAuthView] = useState<AuthView>("app");
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const [comfortOpen, setComfortOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Real sign-out when the gate provides it; otherwise the demo sign-in stub.
  const doSignOut = onSignOut ?? (() => setAuthView("signin"));

  const nav = t.nav;
  const active = {
    home: location.pathname === "/",
    children: location.pathname === "/children",
    assign: location.pathname === "/assign",
    export: location.pathname === "/export",
    link: location.pathname === "/link",
    consent: location.pathname === "/consent",
    settings: location.pathname === "/settings",
  };

  function handleSendLink() {
    if (sending) return;
    setSending(true);
    setTimeout(() => {
      setSending(false);
      setAuthView("sent");
    }, 800);
  }

  function goTo(path: string) {
    navigate(path);
    setNavOpen(false);
  }

  if (authView === "signin") {
    return (
      <div className="zp-root" style={{ fontFamily: "var(--font-body)", color: "var(--ink)", background: "var(--bg)", minHeight: "100vh" }}>
        <SignInScreen
          dict={dict}
          locale={locale}
          email={email}
          sending={sending}
          onEmail={setEmail}
          onSend={handleSendLink}
          setLocale={setLocale}
        />
      </div>
    );
  }

  if (authView === "sent") {
    return (
      <div className="zp-root" style={{ fontFamily: "var(--font-body)", color: "var(--ink)", background: "var(--bg)", minHeight: "100vh" }}>
        <SentScreen
          dict={dict}
          email={email}
          onContinue={() => setAuthView("app")}
          onDifferentEmail={() => setAuthView("signin")}
          onSimulateExpired={() => setAuthView("expired")}
        />
      </div>
    );
  }

  if (authView === "expired") {
    return (
      <div className="zp-root" style={{ fontFamily: "var(--font-body)", color: "var(--ink)", background: "var(--bg)", minHeight: "100vh" }}>
        <ExpiredScreen dict={dict} onSend={handleSendLink} />
      </div>
    );
  }

  // App shell
  return (
    <div
      className="zp-root"
      data-nav-open={String(navOpen)}
      style={{ fontFamily: "var(--font-body)", color: "var(--ink)", background: "var(--bg)", minHeight: "100vh", fontSize: 16, display: "flex" }}
    >
      {/* Nav scrim — mobile drawer backdrop */}
      <div
        className="znav-scrim"
        onClick={() => setNavOpen(false)}
        style={{ position: "fixed", inset: 0, background: "rgba(35,44,56,.32)", zIndex: 55 }}
      />

      {/* Nav rail */}
      <aside
        className="znav-rail"
        style={{ flex: "none", width: 262, background: "var(--surface)", borderInlineEnd: "1px solid var(--line)", display: "flex", flexDirection: "column", position: "sticky", top: 0, height: "100vh" }}
      >
        <div style={{ padding: "22px 20px 14px", display: "flex", alignItems: "center", gap: 11, justifyContent: "space-between" }}>
          <span style={{ display: "flex", alignItems: "center", gap: 11 }}>
            <ZooyloLogo size={34} />
            <span style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 23, color: "var(--brand)", letterSpacing: "-.02em" }}>zooylo</span>
          </span>
          <button
            className="zhamb"
            onClick={() => setNavOpen(false)}
            title="Close menu"
            style={{ width: 38, height: 38, border: 0, background: "var(--surface-sunk)", borderRadius: "var(--r-sm)", cursor: "pointer", color: "var(--ink-soft)", display: "grid", placeItems: "center" }}
          >
            <IconClose />
          </button>
        </div>

        <nav style={{ flex: 1, padding: "8px 16px", display: "flex", flexDirection: "column", gap: 4, overflowY: "auto", overflowX: "hidden" }}>
          <span style={{ fontSize: 11.5, fontWeight: 700, letterSpacing: ".14em", textTransform: "uppercase", color: "var(--ink-faint)", padding: "8px 12px 4px" }}>{nav.space}</span>
          <NavItem label={nav.home} active={active.home} onClick={() => goTo("/")} icon={<IconHome />} />
          <NavItem label={nav.children} active={active.children} onClick={() => goTo("/children")} icon={<IconChildren />} />
          <NavItem label={nav.assign} active={active.assign} onClick={() => goTo("/assign")} icon={<IconAssign />} />
          <span style={{ fontSize: 11.5, fontWeight: 700, letterSpacing: ".14em", textTransform: "uppercase", color: "var(--ink-faint)", padding: "14px 12px 4px" }}>Share</span>
          <NavItem label={nav.export} active={active.export} onClick={() => goTo("/export")} icon={<IconExport />} />
          <NavItem label={nav.link} active={active.link} onClick={() => goTo("/link")} icon={<IconLink />} />
          <NavItem label={nav.consent} active={active.consent} onClick={() => goTo("/consent")} icon={<IconConsent />} />
        </nav>

        <div style={{ padding: "14px 16px", borderTop: "1px solid var(--line)" }}>
          <NavItem label={nav.settings} active={active.settings} onClick={() => goTo("/settings")} icon={<IconSettings />} />
          <div style={{ display: "flex", alignItems: "center", gap: 11, padding: "8px 10px", background: "var(--surface-warm)", borderRadius: "var(--r-md)", marginTop: 4 }}>
            <span style={{ width: 38, height: 38, borderRadius: "50%", background: "var(--brand-tint)", display: "grid", placeItems: "center", flex: "none" }}>
              <IconUser />
            </span>
            <div style={{ minWidth: 0, flex: 1 }}>
              <b style={{ display: "block", fontSize: 14, color: "var(--ink-deep)", fontFamily: "var(--font-body)", lineHeight: 1.2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{accountEmail ?? "Your account"}</b>
              <span style={{ fontSize: 12, color: "var(--ink-faint)" }}>Signed in</span>
            </div>
            <button
              onClick={doSignOut}
              aria-label={dict.common.signOut}
              title={dict.common.signOut}
              style={{ flex: "none", width: 44, height: 44, border: 0, background: "transparent", color: "var(--ink-faint)", borderRadius: "var(--r-sm)", cursor: "pointer", display: "grid", placeItems: "center" }}
            >
              <IconSignOut />
            </button>
          </div>
        </div>
      </aside>

      {/* Main column */}
      <div className="zp-main" style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}>
        {/* Top bar */}
        <header style={{ position: "sticky", top: 0, zIndex: 20, background: "var(--bg)", borderBottom: "1px solid var(--line)", padding: "0 28px", minHeight: 70, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14, minWidth: 0 }}>
            <button
              className="zhamb"
              onClick={() => setNavOpen(true)}
              title="Menu"
              style={{ flex: "none", width: 42, height: 42, border: "1px solid var(--line)", background: "var(--surface)", borderRadius: "var(--r-md)", cursor: "pointer", display: "grid", placeItems: "center", color: "var(--ink-soft)" }}
            >
              <IconMenu />
            </button>
            <span className="ztopbar-eyebrow" style={{ fontSize: 11.5, fontWeight: 700, letterSpacing: ".14em", textTransform: "uppercase", color: "var(--ink-faint)", whiteSpace: "nowrap" }}>Service portal</span>
          </div>
          <ComfortCluster
            dict={dict}
            locale={locale}
            calm={calm}
            bigText={bigText}
            spacing={spacing}
            contrast={contrast}
            dark={dark}
            toggle={toggle}
            setLocale={setLocale}
            onOpenPanel={() => setComfortOpen(true)}
          />
        </header>

        <main style={{ flex: 1, overflowY: "auto" }}>
          <div style={{ maxWidth: 1080, margin: "0 auto", padding: "30px 28px 60px" }}>
            <Outlet context={{ signOut: doSignOut, userId: accountId, email: accountEmail }} />
          </div>
        </main>
      </div>

      {comfortOpen && (
        <ComfortPanel
          dict={dict}
          locale={locale}
          calm={calm}
          bigText={bigText}
          spacing={spacing}
          contrast={contrast}
          dark={dark}
          toggle={toggle}
          setLocale={setLocale}
          onClose={() => setComfortOpen(false)}
        />
      )}
    </div>
  );
}
